import { type TemplateResult } from '@design.estate/dees-element';
import type { DeesChartBar } from './component.js';

export const renderChartBar = (component: DeesChartBar): TemplateResult => {
  return component.renderChartFrame();
};
